import React from 'react'

import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

import { CONFIG } from '../../Config/config'
import { isLocal, getPosthogCrossDomainParams } from '../../Utils/Functions'
import { authorization } from 'Module/Auth/Auth'

export const PostHogProviderWrapper = ({ children }) => {
  const enablePosthog =
    posthog && posthog.init && CONFIG.POSTHOG_KEY && CONFIG.POSTHOG_HOST

  if (enablePosthog) {
    const user = authorization.getUser()
    try {
      const { distinct_id, session_id } = getPosthogCrossDomainParams()
      const posthogConfig = {
        api_host: CONFIG.POSTHOG_HOST,
        disable_web_experiments: !isLocal() ? false : true, // false enables.
        bootstrap: {
          featureFlags: {
            is_braze_enabled: false,
          },
        },
      }
      if (distinct_id) {
        posthogConfig.bootstrap.distinctID = distinct_id
      }
      if (session_id) {
        posthogConfig.bootstrap.sessionID = session_id
      }
      posthog.init(CONFIG.POSTHOG_KEY, posthogConfig)
      if (user) {
        posthog.identify(user.id, {
          email: user.email,
        })
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log({
        message: 'Error while initializing PostHog',
        error,
      })
    }

    return <PostHogProvider client={posthog}>{children}</PostHogProvider>
  }
  return children
}
